import { Navigate, Route, Routes } from 'react-router-dom';

import AppLayout from '@/app/(app)/_layout';
import AppHome from '@/app/(app)/index';
import DatabaseScreen from '@/app/(app)/database/[id]';
import PageScreen from '@/app/(app)/page/[id]';
import SettingsScreen from '@/app/(app)/settings/index';
import ConnectionsScreen from '@/app/(app)/settings/connections';
import NotionImportScreen from '@/app/(app)/settings/import/notion';
import MembersSettingsScreen from '@/app/(app)/settings/members';
import LlmModelsSettingsScreen from '@/app/(app)/settings/llm-models';
import LibraryScreen from '@/app/(app)/library/index';
import FinanceScreen from '@/app/(app)/finance/index';
import ChatShell from '@/app/(app)/chat/index';
import SearchScreen from '@/app/(app)/search/index';
import RootIndex from '@/app/index';
import LoginScreen from '@/app/(auth)/login';
import DesignSystemScreen from '@/app/design-system';
import NotFoundScreen from '@/app/+not-found';

export function AppRoutes() {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <Routes>
        <Route path="/" element={<RootIndex />} />
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/design-system" element={<DesignSystemScreen />} />
        <Route element={<AppLayout />}>
          <Route path="/app" element={<AppHome />} />
          <Route path="/page/:id" element={<PageScreen />} />
          <Route path="/database/:id" element={<DatabaseScreen />} />
          <Route path="/library" element={<LibraryScreen />} />
          <Route path="/finance" element={<Navigate to="/finance/transactions" replace />} />
          <Route path="/finance/transactions" element={<FinanceScreen />} />
          <Route path="/finance/transactions/new" element={<FinanceScreen />} />
          <Route path="/finance/transactions/import" element={<FinanceScreen />} />
          <Route path="/finance/transactions/smart-import" element={<FinanceScreen />} />
          <Route path="/finance/transactions/smart-import/:batchId" element={<FinanceScreen />} />
          <Route path="/finance/transactions/:id" element={<FinanceScreen />} />
          <Route path="/finance/budgets" element={<FinanceScreen />} />
          <Route path="/finance/reports" element={<FinanceScreen />} />
          <Route
            path="/finance/master"
            element={<Navigate to="/finance/master/accounts" replace />}
          />
          <Route path="/finance/master/currencies" element={<FinanceScreen />} />
          <Route path="/finance/master/accounts" element={<FinanceScreen />} />
          <Route path="/finance/master/fx" element={<FinanceScreen />} />
          <Route path="/finance/master/categories" element={<FinanceScreen />} />
          <Route path="/chat/*" element={<ChatShell />} />
          <Route path="/search" element={<SearchScreen />} />
          <Route path="/search/page/:id" element={<SearchScreen />} />
          <Route path="/search/database/:id" element={<SearchScreen />} />
          <Route path="/settings" element={<SettingsScreen />} />
          <Route path="/settings/connections" element={<ConnectionsScreen />} />
          <Route path="/settings/import/notion" element={<NotionImportScreen />} />
          <Route path="/settings/members" element={<MembersSettingsScreen />} />
          <Route path="/settings/llm-models" element={<LlmModelsSettingsScreen />} />
        </Route>
        <Route path="/(app)" element={<Navigate to="/app" replace />} />
        <Route path="/(auth)/login" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<NotFoundScreen />} />
      </Routes>
    </div>
  );
}
